import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { NativeImageGenerationService } from '../services/api/services/nativeImageGenerationService';
import { loadArticleCovers } from './studio-covers';
export default function StudioCover({ articleId }: { articleId: string }) {
  const [failed, setFailed] = useState(false);
  const current = useQuery({
    queryKey: ['studio-selected-cover', articleId],
    queryFn: ({ signal }) => loadArticleCovers([articleId], signal),
    staleTime: 30_000,
    retry: false,
  });
  const status = useQuery({
    queryKey: ['studio-cover', articleId],
    queryFn: () => NativeImageGenerationService.getStatus(articleId),
    staleTime: 60_000,
    retry: false,
  });
  const cover =
    current.data?.[articleId] ??
    status.data?.jobs.find(
      (job) => job.slotType === 'FEATURED' && job.status === 'COMPLETED'
    )?.publicUrl;
  if (!cover || failed) return null;
  return (
    <div className="desk-cover">
      <img
        src={cover}
        alt="Generated cover preview"
        loading="lazy"
        onError={() => setFailed(true)}
      />
      {status.data && (
        <span>
          {status.data.run.completedCount} / {status.data.run.expectedCount}{' '}
          images prepared
        </span>
      )}
    </div>
  );
}
